import React from 'react'
import {fmN, fmP} from '../../helpers/format'

const _compare = (vsAvg) => {
    if (vsAvg === null || vsAvg === undefined) return '—'
    if (vsAvg > 1.25) return <span style={{color: '#cf1322'}}>cao hơn TB {((vsAvg - 1) * 100).toFixed(0)}%</span>
    if (vsAvg < 0.8) return <span style={{color: 'var(--gen-fg)'}}>thấp hơn TB {((1 - vsAvg) * 100).toFixed(0)}%</span>

    return <span style={{color: 'var(--ink-3)'}}>quanh TB</span>
}

// Bảng 8 cột theo bản mẫu, thêm cột Sản phẩm lỗi cạnh Lượt ghi nhận (GAP-07)
const MetricTable = ({unit, table, summary}) => {
    const unitLower = unit.toLowerCase()
    const rows = table.filter(row => row.hits > 0 || row.output)

    return (
        <div className="scroll">
            <table className="xl">
                <thead>
                <tr>
                    <th className="lab">{unit}</th>
                    <th>Lượt ghi nhận</th>
                    <th>Sản phẩm lỗi</th>
                    <th>Tỉ trọng</th>
                    <th>Tỉ lệ / tổng SL</th>
                    <th>SL qua {unitLower}</th>
                    <th>Tỉ lệ thật</th>
                    <th>So trung bình</th>
                </tr>
                </thead>
                <tbody>
                {rows.length ? rows.map(row => (
                    <tr key={row.dim_id}>
                        <td className="lab">{row.dim_name || row.dim_id}</td>
                        <td className="v">{fmN(row.hits)}</td>
                        <td className="v">{fmN(row.items)}</td>
                        <td className="v">{fmP(row.share)}</td>
                        <td className="v">{summary.output ? fmP(row.hits / summary.output) : '—'}</td>
                        <td className="v">{row.error_group ? '—' : fmN(row.output)}</td>
                        <td className="v"><b>{row.error_group ? '—' : fmP(row.rate)}</b></td>
                        <td className="v">{_compare(row.vs_avg)}</td>
                    </tr>
                )) : (
                    <tr><td colSpan="8" className="empty">Không có dữ liệu.</td></tr>
                )}
                <tr className="total">
                    <td className="lab">Tổng</td>
                    <td className="v">{fmN(summary.hits)}</td>
                    <td className="v">{fmN(summary.items)}</td>
                    <td className="v">100%</td>
                    <td className="v">{fmP(summary.rate)}</td>
                    <td className="v">{fmN(summary.output)}</td>
                    <td className="v"><b>{fmP(summary.rate)}</b></td>
                    <td className="v">—</td>
                </tr>
                </tbody>
            </table>
        </div>
    )
}

export default MetricTable
